import _ from 'lodash'
import CommonMixin from '../../mixins/common'
import DeliverySelect from './components/DeliverySelect'
import PaySelect from './components/PaySelect'
import UserTypeSelect from './components/UserTypeSelect'
import ProfileSelect from './components/ProfileSelect'
import ProductList from './components/ProductList'
import OrderTotal from './components/OrderTotal'
import PropertyInput from './components/PropertyInput'
import PropertyPhoneInput from './components/PropertyPhoneInput'
import LocationInput from './components/LocationInput'
import EdostDelivery from './components/EdostDelivery'

export default {
  name: 'order',
  isAjaxInn: false,
  issetInn: false,
  props: {
    application: {
      type: [Object, Array],
      default () {
        return {}
      }
    }
  },
  mixins: [CommonMixin],
  components: {
    DeliverySelect,
    PaySelect,
    UserTypeSelect,
    ProfileSelect,
    ProductList,
    OrderTotal,
    PropertyInput,
    PropertyPhoneInput,
    LocationInput,
    EdostDelivery
  },
  data () {
    return {
      issetInn: false,
      errorList: [],
      address: {},
      edost_office: false,
      deliveryHasOffice: false,
      isAjaxProcess: false,
      isPhoneSuccess: false,
      isProfileChange: false,
      isFirstLoad: true
    }
  },
  computed: {

    issetInn(){
      return this.issetInn;
    },
    form () {
      return this.application.form
    },
    order () {
      return this.application.order
    },
    orderProperties () {
      if(typeof this.order['ORDER_PROP']!== 'undefined')
      return this.order['ORDER_PROP'].properties
    },
    personTypeList () {
      if(typeof this.order['PERSON_TYPE']!== 'undefined')
      return this.order['PERSON_TYPE']
    },
    deliveryTypeList () {
      if(typeof this.order['DELIVERY']!== 'undefined')
      return this.order['DELIVERY']
    },
    payTypeList () {
      if(typeof this.order['PAY_SYSTEM']!== 'undefined')
      return this.order['PAY_SYSTEM']
    },
    userProfileList () {
      if(typeof this.order['USER_PROFILES']!== 'undefined')
      return this.order['USER_PROFILES']
    },
    storeList () {
      if (this.currentDelivery) {
        const idList = this.currentDelivery['STORE'].map(item => +item)
        return _.mapValues(this.order['STORE_LIST'], item => {
          console.log(item)
          if (idList.includes(+item.ID)) {
            return item
          }
        })
      } else {
        return {}
      }
    },
    productRows () {
      if(typeof this.order['GRID']!== 'undefined')
      return this.order['GRID']['ROWS']
    },
    orderTotal () {
      return this.order['TOTAL']
    },
    properties () {
      return this.getComputedProperties()
    },
    currentDelivery () {
      return this.getCheckedItem(this.deliveryTypeList)
    },
    isStoreHasSelected () {
      return this.currentDelivery && this.currentDelivery['STORE'].length > 0
    }
  },
  watch: {

    'form.fields.personType' (newValue, oldValue) {
      this.form.fields.personTypeOld = oldValue
      this.refreshOrder()
    },
    'form.fields.deliveryType' () {
      this.refreshOrder()
    },
    'form.properties.innU' () {
      this.checkInn()
    },
    'form.fields.payType' () {
      this.refreshOrder()
    },
    'issetInn' () {
   //   this.refreshOrder()
    },
    'form.fields.userProfile' (newValue) {
      if (newValue !== 0) {
        this.isProfileChange = true
        this.refreshOrder()
      }
    }
  },
  created () {
  }, // Действия при создании
  mounted () {
    this.$nextTick(function () {
      this.refreshOrder()
      window.addEventListener('updateBasket', this.onBasketUpdate)
    })
  },
  methods:

    {
      innValid() {
        let inn = this.form.properties.innU.replace(/[^0-9]/g, '');
        if(typeof inn !== "undefined" && (inn.length === 12 || inn.length === 10)) {
          //  this.checkUser('login')
         // this.$v.form.properties.innU.$touch()
        }
        return inn.length === 12 || inn.length === 10
      },
      checkInn () {
        this.issetInn = false
        this.errors = []
        this.message = ''

        let userData = null
        let params = new FormData()
        let inn = this.form.properties.innU.replace(/[^0-9]/g, '');
        console.error('check inn',inn,this.innValid())

        console.log('profile ID',this.form.fields.userProfile);

        if (this.innValid() && parseInt(this.form.fields.userProfile)===0) {
        //  this.$v.inn.$touch();
          params.append('inn', inn)
          console.error('POSTA',inn)
          this.$http.post('/ajax_new/User/checkInn/', params).then(request => {
            if (request.data.status) {
              this.issetInn = true
            } else {
              this.issetInn = false
            }
            this.$forceUpdate();
          //  this.$v.$touch();
          }).catch(error => {
            console.error(error)
          })
        }
      },

    onUserProfileSelect (userProfile) {
      console.log('userProfile updated:', userProfile)
      this.form.fields.userProfile = userProfile
      this.refreshOrder()
    },
    onSubDeliveryChange (subDeliveryItem) {
      console.log('sub change', subDeliveryItem)
      this.edost_office = subDeliveryItem
    },
    onLocationUpdate ($event) {
      if (this.form.fields.personType === 1) {
        this.form.properties.addressF = $event.CODE
      } else {
        this.form.properties.addressU = $event.CODE
      }
      this.refreshOrder()
    },
    onZipUpdate ($event) {
      console.log($event)
      this.form.properties.zipF = $event
      if ($event.length === 6) {
        this.refreshOrder()
      }
    },
    onPersonTypeUpdate ($event) {
      console.log('personType updated:', $event)
      this.form.fields.personType = $event
      this.refreshOrder()
    },
    onBasketUpdate () {
      alert('onBasketUpdate')
    },
    getComputedProperties () {
      let computedPropertyList = {}
      for (const propertyName in this.application.info['propertyNameToIdList']) {
        if (!this.application.info['propertyNameToIdList'].hasOwnProperty(
            propertyName)) {
          continue
        }
        if (this.isAjaxProcess) {
          computedPropertyList[propertyName] = false
        } else {
          computedPropertyList[propertyName] = this.getProperty(propertyName)
        }
      }
      return computedPropertyList
    },
    getFormPropertyIdByName (name) {
      return this.application.info.propertyNameToIdList[name]
    },
    getFormPropertyNameById (id) {
      const list = this.application.info.propertyNameToIdList
      for (const name in list) {
        if (+list[name] === +id) {
          return name
        }
      }
    },
    getProperty (propertyName) {
      if (!this.isAjaxProcess) {
        return this.getPropertyById(this.getFormPropertyIdByName(propertyName))
      }
      return false
    }, // Получить свойство по имени
    getPropertyById (propertyId) {
      for (const index in this.orderProperties) {
        if (!this.orderProperties.hasOwnProperty(index)) {
          continue
        }
        if (+this.orderProperties[index].ID === propertyId) {
          return this.orderProperties[index]
        }
      }
      return false
    }, // Получить свойство по ИД
    getPropertyByCode (propertyCode) {
      for (const index in this.orderProperties) {
        if (!this.orderProperties.hasOwnProperty(index)) {
          continue
        }
        if (this.orderProperties[index]['CODE'] === propertyCode) {
          return this.orderProperties[index]
        }
      }
      return false
    }, // Получить свойство по символьному коду
    findByInn () {
      this.errors = [];
      this.message = '';
   // this.form.properties.innU.$touch();

      if (!this.form.properties.innU.$invalid) {
        let params = new FormData()
      //  console.log(this.form.properties.innU);
        console.log(this.form.properties.innU,'this.form.properties.innU.get()');
        console.log(this.orderProperties,'this.orderProperties');
        params.append('inn', this.form.properties.innU)

        this.isAjaxInn = true

        this.$http.post('/ajax_new/Dadata/findById/', params).then(request => {
          this.isAjaxInn = false

          if (request.data.status && typeof request.data.data.result!=='undefined') {
            let result = request.data.data.result;

            if(typeof result!=='undefined' && typeof result.organizationName!=='undefined'  && result.organizationName!==null  && result.organizationName.length>0){
              this.form.properties.orgranization_nameU = result.organizationName;
              this.form.properties.full_organization_nameU = result.fullOrganizationName;
              this.form.properties.legal_addressU = result.legalAddress;
              this.form.properties.organization_phoneU = result.organizationPhone;
              this.form.properties.kpp =  typeof result.kpp !=='undefined' && result.kpp.length>0?result.kpp.toString():'';
            }else{
              this.errors.push('Компания не найдена!');
            }


          } else {
            this.errors = request.data.errors;
          }
        })
      }
    },
    refreshOrderData () {
      this.form.fields.userProfile = this.getCheckedItemId(
        this.userProfileList) || this.form.fields.userProfile
      this.form.fields.deliveryType = this.getCheckedItemId(
        this.deliveryTypeList)
      console.log('parent', this.form.fields.deliveryType)
      this.form.fields.payType = this.getCheckedItemId(this.payTypeList)
      this.refreshOrderProperties()
    }, // Инициализация полей
    refreshOrderProperties () {
      let phone = '';
      let properties = this.orderProperties
      for (const index in properties) {
        if (!properties.hasOwnProperty(index)) {
          continue
        }
        const propertyId = _.toInteger(properties[index].ID)
        const propertyFormName = this.getFormPropertyNameById(propertyId)
        const propertyCode = properties[index].CODE
        if (!_.isArray(properties[index].VALUE) &&
          !_.first(properties[index].VALUE)) {
          if (!this.form.properties[propertyFormName]) {
            this.form.properties[propertyFormName] = ''
          }
        } else {
          do {
            if (propertyCode === 'PHONE') {
              this.form.properties[propertyFormName] = ''
              let phoneValue = _.first(properties[index].VALUE)
                .replace(/[^0-9.]/g, '')
              if (phoneValue.length === 11) {
                phoneValue = phoneValue.substr(1)
              }
              if (phoneValue.length === 10) {
                this.form.properties[propertyFormName] = phoneValue
              }

              phone = phoneValue;

              break
            }
            this.form.properties[propertyFormName] = _.first(
              properties[index].VALUE)
          } while (false)
        }

       // console.log(phoneValue,"phoneValue");

        // Постобработка свойств
        if (propertyCode === 'PHONE_SUCCESS') {
          this.isPhoneSuccess = (this.form.properties[propertyFormName] === 'Y' && this.form.fields.userProfile !== 0) || phone.length>0
        }

        if (propertyCode === 'ADDRESS') {
          let params = new FormData()
          params.append('CODE', properties[index].VALUE[0])
          this.$http.post('/local/components/sb/sale.location.selector.search/get.php', params).then(response => {
            let data = response.data.data['ITEMS']
            data.map(item => {
              item.value = item.DISPLAY
              return item
            })
            this.address = data[0]
          })
        }
      }
      // if (this.form.properties[this.service.locationPropertyId.toString()]) {
      //   this.logToConsole('Свойство Location не пустое: ' + this.form.properties[this.service.locationPropertyId.toString()])
      //   this.setCityName(this.form.properties[this.service.locationPropertyId.toString()])
      // }
    }, // Иниициализация свойств заказа
    refreshOrder () {
      if (this.isAjaxProcess) {
        return
      }
      this.isAjaxProcess = true

      let params = new FormData()
      params = this.getRefreshFormData(params)
      let vm = this
      this.$http.post(this.application.component.ajaxUrl, params)
        .then(response => {
          if (response.data.success === 'N') {
            document.location.href = response.data.redirect
          }
          vm.application.order = response.data.order
          vm.refreshOrderData()
          vm.isAjaxProcess = false
        })
        .catch(error => {
          vm.isAjaxProcess = false
          console.error(error)
        })
    }, // Обновление данных заказа
    getRefreshFormData (params) {


      params.append('order[sessid]', this.application.formData.sessid)
      params.append('order[' +
        this.application.component.params['ACTION_VARIABLE'] + ']',
        this.application.formData.action) // saveOrderAjax
      params.append('order[location_type]',
        this.application.formData.location_type) // code
      params.append('order[BUYER_STORE]', this.form.fields.store)
      params.append('order[DELIVERY_ID]', this.form.fields.deliveryType)
      params.append('order[PAY_SYSTEM_ID]', this.form.fields.payType)
      params.append('order[PERSON_TYPE]', this.form.fields.personType)
      params.append('order[PERSON_TYPE_OLD]', this.form.fields.personTypeOld)
      this.form.fields.personTypeOld = this.form.fields.personType
      params.append('order[profile_change]', this.isProfileChange ? 'Y' : 'N')
      if (this.isProfileChange) {
        this.isProfileChange = false
      }
      params.append('order[PROFILE_ID]', this.form.fields.userProfile)
      params.append('order[ORDER_DESCRIPTION]', this.form.fields.description)
      params.append('order[RECENT_DELIVERY_VALUE]',
        this.form.fields.recentDelivery)
      // this.form.fields.recentDelivery = this.form.properties[this.service.locationPropertyId]
      // params.append('order[PAY_CURRENT_ACCOUNT]', this.service.isPayInner ? 'Y' : 'N')
      // params.append('order[ZIP_PROPERTY_CHANGED]', this.service.isZipPropertyChange ? 'Y' : 'N')

      let properties = this.orderProperties
      for (const index in properties) {
        if (!properties.hasOwnProperty(index)) {
          continue
        }
        const propertyId = _.toInteger(properties[index].ID)
        const propertyFormName = this.getFormPropertyNameById(propertyId)
        if (!this.form.properties[propertyFormName]) {
          continue
        }
        if (propertyId === 'phone_successF' || propertyId === 'phone_successU') {
          params.append('order[ORDER_PROP_' + propertyId + ']',
            this.isPhoneSuccess ? 'Y' : 'N')
          continue
        }
        params.append('order[ORDER_PROP_' + propertyId + ']',
          this.form.properties[propertyFormName])
      }
      params.append('sessid', this.application.formData.sessid)
      params.append('via_ajax', this.application.formData.via_ajax)
      params.append('SITE_ID', this.application.component.siteId)
      params.append('signedParamsString',
        this.application.component.signedParamsString)
      params.append(this.application.component.params['ACTION_VARIABLE'],
        'refreshOrderAjax')
      return params
    }, // Заполнение запроса для обновления заказа
    saveOrder () {
      if (this.isAjaxProcess) {
        return
      }
      this.isAjaxProcess = true

      let params = new FormData()
      params = this.getSaveFormData(params)
      console.log(params)
      let vm = this
      let asdf = 0;
      this.$http.post(vm.application.component.ajaxUrl, params)
        .then(response => {
          if (response.data.order.ID > 0 && response.data.order.REDIRECT_URL) {
             asdf = 1;
            this.$metrika.reachGoal('ordering');
            document.location.href = response.data.order.REDIRECT_URL
          }
          vm.isAjaxProcess = false
          if (response.data.order.ERROR) {
            vm.errorList = response.data.order.ERROR
           // $(".order-error").show();
            for (let el of document.querySelectorAll('.order-error')) el.style.visibility = 'visible';
          } else {
            vm.errorList = []
            if(asdf==1){

            }else{
              this.$metrika.reachGoal('ordering');
            }
            for (let el of document.querySelectorAll('.order-error')) el.style.visibility = 'hidden';
          //  $(".order-error").hide();
          }


        })
        .catch(error => {
          vm.isAjaxProcess = false
          console.error(error)
        })
    }, // Сохранение заказа
    getSaveFormData (params) {
      params.append('sessid', this.application.formData.sessid)
      params.append(this.application.component.params['ACTION_VARIABLE'],
        'saveOrderAjax')
      params.append('location_type', this.application.formData.location_type)
      params.append('BUYER_STORE', this.form.fields.store)
      params.append('PERSON_TYPE', this.form.fields.personType)
      params.append('PERSON_TYPE_OLD', this.form.fields.personTypeOld)
      params.append('DELIVERY_ID', this.form.fields.deliveryType)
      params.append('PAY_SYSTEM_ID', this.form.fields.payType)
      params.append('PROFILE_ID', this.form.fields.userProfile)
      // params.append('RECENT_DELIVERY_VALUE', this.form.properties[this.service.locationPropertyId])
      params.append('ZIP_PROPERTY_CHANGED', 'Y')

      console.log(this.orderProperties)
      let properties = this.orderProperties
      console.log(properties)
      console.log(this.form.properties)
      for (const index in properties) {
        if (!properties.hasOwnProperty(index)) {
          continue
        }
        const propertyId = _.toInteger(properties[index].ID)
        const propertyFormName = this.getFormPropertyNameById(propertyId)
        if (propertyFormName === 'detail_addressF' || propertyFormName === 'detail_addressU') {
          if (this.edost_office) {
            params.append('ORDER_PROP_' + propertyId, this.edost_office)
            continue
          }
        }

        if (!this.form.properties[propertyFormName]) {
          continue
        }

        console.log(this.isPhoneSuccess)
        if (propertyFormName === 'phone_successF' || propertyFormName === 'phone_successU') {
          console.log(propertyFormName, 'ORDER_PROP_' + propertyId, this.isPhoneSuccess ? 'Y' : 'N')
          params.append('ORDER_PROP_' + propertyId,
            this.isPhoneSuccess ? 'Y' : 'N')
          continue
        }

        params.append('ORDER_PROP_' + propertyId,
          this.form.properties[propertyFormName])
      }

      params.append('ORDER_DESCRIPTION', this.form.fields.description)
      // params.append('PAY_CURRENT_ACCOUNT', this.service.isPayInner ? 'Y' : 'N')
      // params.append('via_ajax', this.application.form.via_ajax);
      params.append('save', 'Y')
      params.append('signedParamsString',
        this.application.component.signedParamsString)
      return params
    } // Заполнение запроса для сохранения заказа
  }
}



// WEBPACK FOOTER //
// ./src/vue/components/order/script.js